<template>
  <div class="container">
    <section id="filter">
      <div class="row mt-2">
        <div class="col-4">
          <input
            placeholder="Tgl. Upload"
            class="form-control m-2"
            :type="tglUploadFilter"
            @focus="tglUploadFilter = 'date'"
            @blur="filter.tglUpload == '' ? (tglUploadFilter = 'text') : (tglUploadFilter = 'date')"
            id="date"
            v-model="filter.tglUpload"
          />
        </div>
        <div class="col-4">
          <input placeholder="Batch" class="form-control m-2" type="text" list="batch" v-model="filter.batch" @keyup="getDataBatch($event)" />
          <datalist id="batch">
            <option v-for="(batch, index) in dataBatch" :key="index">
              {{ batch.batch }}
            </option>
          </datalist>
        </div>
        <div class="col-4">
          <select class="form-select m-2" v-model="filter.client" :class="filter.client ? '' : 'text-secondary'">
            <option value="" selected>
              {{ filter.client ? "none" : "Client" }}
            </option>
            <option v-for="client in dataClient.content" :key="client.id" class="text-dark" :value="client.id">
              {{ client.name }}
            </option>
          </select>
        </div>
        <div class="col-8">
          <select class="form-select m-2" v-model="filter.reason" :class="filter.reason ? '' : 'text-secondary'">
            <option class="text-dark" value="" selected>
              {{ filter.reason ? "none" : "Status" }}
            </option>
            <option class="text-dark" value="1">1 - ID Stasiun terdeteksi sama</option>
            <option class="text-dark" value="2">2 - Long-Lat terdeteksi sama</option>
            <option class="text-dark" value="3">3 - ID Stasiun & Long-Lat terdeteksi sama</option>
            <option class="text-dark" value="4">4 - Longitude Latitude terdeteksi sama di File, ID Stasiun terdeteksi sama di Perangkat</option>
            <option class="text-dark" value="5">5 - ID Stasiun terdeteksi sama di File, Longitude Latitude terdeteksi sama di Perangkat</option>
          </select>
        </div>
        <div class="col-4">
          <button class="btn btn-success rounded-pill shadow text-white mx-2" @click="getDuplikasi(0)">
            <i class="fa fa-search"></i>
          </button>
          <button class="btn btn-success rounded-pill shadow text-white mx-2" @click="refresh()">
            <i class="fa fa-refresh"></i>
          </button>
        </div>
      </div>
    </section>
    <div class="card mt-4">
      <div class="card-header p-4 pb-0">
        <div class="row">
          <div class="col-6">
            <b>Perangkat</b>
          </div>
          <div class="col-6 d-flex justify-content-end gap-3">
            <button class="btn btn-sm mx-1 px-4" @click="downloadExcel()" data-bs-toggle="modal" data-bs-target="#modalLoading">
              <i class="fa fa-print text-success"></i>
              &nbsp; download
            </button>
            <!-- <div class="btn-group" role="group">
              <button type="button" class="btn btn-success btn-sm px-2 py-1" title="geser" :disabled="!actionGroupButtonActive" @click="geserSelected()">
                <i class="fa fa-exchange text-white"></i>
              </button>
              <button type="button" class="btn btn-success btn-sm px-2 py-1" title="gudangkan" :disabled="!actionGroupButtonActive">
                <i class="fa fa-check-circle text-white"></i>
              </button> -->
            <!-- </div> -->
          </div>
        </div>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <TableDuplikasi :rows="rows" :data-length="dataLength" :page-length="pageLength" :current-page="currentPage" :offset="offset" :size="size" @get-data="getDuplikasi(0)">
          <template #button>
            <Paginate
              v-model="pagination"
              :page-count="pageLength"
              :page-range="5"
              :margin-pages="1"
              :click-handler="movePage"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :first-last-button="true"
              first-button-text="<<"
              last-button-text=">>"
            />
          </template>
        </TableDuplikasi>
      </div>
    </div>
    <modal modalName="modalLoading" :isFooter="false" :isHeader="false">
      <template #body>
        <div class="text-center">
          <span>
            <h2 class="fs-5">
              {{ store.state.isLoadingDownload ? "Loading Process" : "done !" }}
            </h2>
            <i v-show="store.state.isLoadingDownload" class="fa fa-spinner fa-lg fa-spin"></i>
            <br />
            <p v-show="processFailed" class="fs-5 text-danger">Proses Gagal !</p>
            <button v-show="!store.state.isLoadingDownload" class="btn btn-outline-success mt-4 me-2" data-bs-dismiss="modal" @click="processFailed = false">Ok</button>
            <button v-show="!store.state.isLoadingDownload && processFailed === true" class="btn btn-success mt-4" @click="(processFailed = false), downloadExcel()">Coba Lagi!</button>
          </span>
        </div>
      </template>
    </modal>
  </div>
</template>

<script setup>
import { ref } from "@vue/reactivity";
import { ApiService } from "@/axios/apiService";
import TableDuplikasi from "../../components/perangkat/TableDuplikasi.vue";
import { computed, onMounted } from "@vue/runtime-core";
import Paginate from "vuejs-paginate-next";
import { useStore } from "vuex";
import Modal from "@/components/ModalComponent.vue";

//data
const store = useStore();
const apiService = new ApiService();
const filter = ref({
  tglUpload: "",
  batch: "",
  reason: "",
  client: "",
});
const processFailed = ref(false);
const rows = ref([]);
const dataLength = ref(0);
const pageLength = ref(0);
const size = ref(0);
const currentPage = ref(0);
const dataBatch = ref([]);
const pagination = computed(() => currentPage.value + 1);
const offset = computed(() => {
  if (dataLength.value < 1) {
    return 0;
  } else {
    return 10 * currentPage.value + 1;
  }
});
const dataClient = ref([]);
const tglUploadFilter = ref("text");

const downloadExcel = async () => {
  try {
    store.state.isLoadingDownload = true;
    processFailed.value = false;
    const data = filter.value;
    let params = "";
    if (data.tglUpload !== "" && data.tglUpload !== null) {
      params += `&tglUpload=${data.tglUpload}`;
    }
    if (data.batch !== "" && data.batch !== null) {
      params += `&batch=${data.batch}`;
    }
    if (data.reason !== "" && data.reason !== null) {
      params += `&reason=${data.reason}`;
    }
    if (data.client !== "" && data.client !== null) {
      params += `&client=${data.client}`;
    }
    const response = await apiService.exportExcelDuplikasi(params);
    const href = URL.createObjectURL(response.data);
    let link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", "PERANGKAT-DUPLIKASI" + ".xls"); //or any other extension
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
    store.state.isLoadingDownload = false;
  } catch (error) {
    store.state.isLoadingDownload = false;
    processFailed.value = true;
    console.log(error);
  }
};

const getDataPelanggan = async () => {
  const res = await apiService.getPelanggan(10, 0);
  dataClient.value = res.data;
};

onMounted(async () => {
  await getDuplikasi(currentPage.value);
  await getDataPelanggan();
});

const refresh = async () => {
  filter.value = {
    tglUpload: "",
    batch: "",
    reason: "",
    client: "",
  };
  tglUploadFilter.value = "text";
  await getDuplikasi(0);
};

const getDuplikasi = async (page) => {
  try {
    const data = filter.value;
    store.state.isLoading = true;
    currentPage.value = page;
    let params = "";
    if (data.batch !== "" && data.batch !== null) {
      params += `&batch=${data.batch}`;
    }
    if (data.client !== "" && data.client !== null) {
      params += `&client=${data.client}`;
    }
    if (data.reason !== "" && data.reason !== null) {
      params += `&reason=${data.reason}`;
    }
    if (data.tglUpload !== "" && data.tglUpload !== null) {
      params += `&tglUpload=${data.tglUpload}`;
    }
    filterMove = params;
    const res = await apiService.getDuplikasi(page, params);
    rows.value = res.data.content.map((item) => {
      return {
        ...item,
        checked: false,
      };
    });
    dataLength.value = res.data.totalElements;
    pageLength.value = res.data.totalPages;
    size.value = res.data.size;
    store.state.isLoading = false;
  } catch (error) {
    console.log(error);
    store.state.isLoading = false;
  }
};

let filterMove = "";
const movePage = async (pageNumber) => {
  store.state.isLoading = true;
  currentPage.value = pageNumber - 1;
  const res = await apiService.getDuplikasi(currentPage.value, filterMove);
  rows.value = res.data.content.map((item) => {
    return {
      ...item,
      checked: false,
    };
  });
  dataLength.value = res.data.totalElements;
  pageLength.value = res.data.totalPages;
  size.value = res.data.size;
  store.state.isLoading = false;
};

let timeoutIdBatch;
const getDataBatch = async (e) => {
  try {
    if (timeoutIdBatch) {
      clearTimeout(timeoutIdBatch);
    }
    const data = filter.value.batch;
    if (data && data.length > 2 && e.keyCode !== 8) {
      timeoutIdBatch = setTimeout(async () => {
        const res = await apiService.getBatch(data);
        dataBatch.value = res.data;
      }, 500);
    }
  } catch (error) {
    console.log(error);
  }
};

const geserSelected = () => {
  const selected = rows.value.filter((row) => row.checked);
  if (selected.length > 0) {
    const ids = selected.map((item) => item.id);
    store.dispatch("swalConfirm", {
      text: `data station ${ids.join(", ")} akan digeser ?`,
      text1: "",
      funs: async () => {
        try {
          await apiService.geserkanAll(selected, ids);
          store.dispatch("swalSuccess", {
            text: "data berhasil digeser",
          });
          getDuplikasi(currentPage.value);
        } catch (error) {
          store.dispatch("swalError", {
            code: error.response.status,
            text: error.response.data.message,
          });
          console.log(error);
        }
      },
    });
  } else {
    store.dispatch("swalError", {
      code: "Internal",
      text: "Pilih data terlebih dahulu",
    });
  }
};
</script>
